"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconWrapper = exports.IconContainer = exports.PopupContainer = exports.SidebarContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  svg {\n    cursor: pointer;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  padding: 3px 5px;\n  width: 100px;\n  text-align: center;\n\n  .__slate-sidebar_slateToolbarItem {\n    height: 40px;\n    width: 40px;\n  }\n  .qlStroke {\n    stroke: #bbb;\n    fill: transparent;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n    stroke-width: 1px;\n  }\n  .qlStrokeActive {\n    stroke: #333;\n    fill: transparent;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n    stroke-width: 1.5px;\n  }\n  .qlStrokeMitter {\n    stroke: #bbb;\n    fill: transparent;\n  }\n  .qlStrokeMitterActive {\n    stroke: #333;\n    fill: transparent;\n  }\n  .qlFill {\n    fill: #bbb;\n  }\n  .qlFillActive {\n    fill: #333;\n  }\n  .qlEven {\n    stroke: #bbb;\n    fill: transparent;\n  }\n  .qlEvenActive {\n    stroke: #333;\n    fill: transparent;\n  }\n  .qlColorLabel {\n    fill: #464646;\n    opacity: 0.2;\n  }\n  .qlTransparent {\n    opacity: 0.2;\n  }\n  .qlThin {\n    stroke: #bbb;\n    fill: transparent;\n    stroke-width: 1;\n  }\n  .qlThinActive {\n    stroke: #333;\n    fill: transparent;\n    stroke-width: 1;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 320px;\n  display: ", ";\n  color: rgba(0, 0, 0, 0.65);\n  background-color: #fff;\n  background-clip: padding-box;\n  border-radius: 4px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  position: relative;\n  padding: 10px;\n  left: 20px;\n  top: -140px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 5;\n\n  i {\n    color: #ccc;\n    -webkit-animation: fadeIn 1s; /* Safari, Chrome and Opera > 12.1 */\n    -moz-animation: fadeIn 1s; /* Firefox < 16 */\n    -ms-animation: fadeIn 1s; /* Internet Explorer */\n    -o-animation: fadeIn 1s; /* Opera < 12.1 */\n    animation: fadeIn 1s;\n  }\n\n  i.open {\n    -webkit-animation: spin 1s; /* Safari, Chrome and Opera > 12.1 */\n    -moz-animation: spin 1s; /* Firefox < 16 */\n    -ms-animation: spin 1s; /* Internet Explorer */\n    -o-animation: spin 1s; /* Opera < 12.1 */\n    animation: spin 1s;\n    -webkit-animation-fill-mode: forwards; /* Safari 4.0 - 8.0 */\n    animation-fill-mode: forwards;\n  }\n\n  @keyframes fadeIn {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  @-webkit-keyframes fadeIn {\n    0% {\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n  @-moz-keyframes fadeIn {\n    0% {\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n\n  @-moz-keyframes spin {\n    from {\n      -moz-transform: rotate(0deg);\n    }\n    to {\n      -moz-transform: rotate(45deg);\n    }\n  }\n  @-webkit-keyframes spin {\n    from {\n      -webkit-transform: rotate(0deg);\n    }\n    to {\n      -webkit-transform: rotate(45deg);\n    }\n  }\n  @keyframes spin {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(45deg);\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var SidebarContainer = _styledComponents.default.div(_templateObject());

exports.SidebarContainer = SidebarContainer;

var PopupContainer = _styledComponents.default.div(_templateObject2(), function (props) {
  return props.isOpen ? "block" : "none";
});

exports.PopupContainer = PopupContainer;

var IconContainer = _styledComponents.default.div(_templateObject3());

exports.IconContainer = IconContainer;

var IconWrapper = _styledComponents.default.div(_templateObject4());

exports.IconWrapper = IconWrapper;